var map = {
	"./oops.de-CH.json": 1505,
	"./oops.de-DE.json": 1506,
	"./oops.en-CA.json": 1507,
	"./oops.en-GB.json": 1508,
	"./oops.en-IN.json": 1509,
	"./oops.en-ME.json": 1510,
	"./oops.en-US.json": 1511,
	"./oops.es-EM.json": 1512,
	"./oops.es-ES.json": 1513,
	"./oops.fr-BE.json": 1514,
	"./oops.fr-CA.json": 1515,
	"./oops.fr-CH.json": 1516,
	"./oops.nl-BE.json": 1517,
	"./oops.nl-NL.json": 1518,
	"./oops.pl-PL.json": 1519,
	"./oops.pt-BR.json": 1520
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1504;